import createBrowserHistory from 'history/createBrowserHistory';
import createMemoryHistory from 'history/createMemoryHistory';

export default process.env.BROWSER === 'true' ? createBrowserHistory() : createMemoryHistory();



// WEBPACK FOOTER //
// ./source/client/store/history.js